module.exports = __webpack_public_path__ + "img/db_lorry2.c9b69af3.jpeg";